import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemNotificationComponent } from '../../components/item-notification/item-notification.component';
import { Component, OnInit, inject, OnDestroy, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import Session from '../../utils/session.service';
import Config from '../../utils/config.service';
import CallService from '../../services/call.service';
import Time from '../../utils/timer.service';
import ServiceRestServices from '../../services/service-rest.service';
import ChatService from '../../services/chat.service';
import ChatRestServices from '../../services/chat-rest.service';
import DialogServices from '../../services/dialog.service';
import StatusService from '../../services/status.service';
import Toast from '../../services/toast.service';
import Browser from '../../utils/browser.service';
import UrlUtil from '../../utils/url-util.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import AngularStateHelperService from '../../services/angular-state-helper.service';
import RoutingService from '../../services/routing.service';
import $ from 'jquery';
import { ModalUserFeedbackComponent } from '../../components/modal-user-feedback/modal-user-feedback.component';
import { ModalUserSessionFeedbackComponent } from '../../components/modal-user-session-feedback/modal-user-session-feedback.component';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'call',
	templateUrl: './call.component.html',
	imports: [CommonModule, TranslatePipe, ItemNotificationComponent, FormsModule]
})
export default class CallView implements OnInit, OnDestroy {
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private callService: CallService = inject(CallService);
	private time: Time = inject(Time);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private chatService: ChatService = inject(ChatService);
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private dialogServices: DialogServices = inject(DialogServices);
	private statusService: StatusService = inject(StatusService);
	private toast: Toast = inject(Toast);
	private browser: Browser = inject(Browser);
	private urlUtil: UrlUtil = inject(UrlUtil);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private angularStateHelperService: AngularStateHelperService = inject(AngularStateHelperService);
	private routingService: RoutingService = inject(RoutingService);

	vm: any = undefined;
	watcher: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];

	constructor(private ngZone: NgZone) {
		this.vm = this;
		this.vm.initialized = false;
	}

	ngOnInit() {
		this.callService.setCallWindowActive(true);
		this.routingService.validateAccess('call').then(() => {
			this.onResolve();
		});
	}
	
	ngOnDestroy() {
		this.callService.setCallWindowActive(false);
		window.onbeforeunload = null; // TODO ANGULAR_2:VALIDATE
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}

	onResolve() {
		this.initialize();

		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, 'onConnectionStateChange',
				(event, newConnectionState) => { this.handleConnectionStateChange(event, newConnectionState); })
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, 'onMediaStateChange',
				(event, parameters) => { this.handleMediaStateChange(event, parameters); })
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, 'onRequestCall',
				(event, parameters) => { this.handleRequestCall(event, parameters); })
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, 'onCallAccepted',
				() => { this.handleOnCallAccepted(); })
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, 'onCallEnded',
				(event, callResolution) => { this.handleOnCallEnded(event, callResolution); })
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, 'onRtcOffer',
				(event, offer) => { this.handleOnRtcOffer(event, offer); })
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, 'onRtcAnswer',
				(event, answer) => { this.handleOnRtcAnswer(event, answer); })
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, 'onRtcIceCandidate',
				(event, iceCandidate) => { this.handleOnRtcIceCandidate(event, iceCandidate); })
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, this.config.getBroadcastConfig().Chat.CLOSE,
				(event, chat) => { this.handleChatClose(event, chat); })
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, this.config.getBroadcastConfig().Chat.NEW_MESSAGE,
				(event, message, chatId) => { this.handleNewMessage(event, message, chatId); })
		);
		
		var currentRemoteVideoEnabled = this.vm.callSettings.remoteVideoEnabled;
		this.watcher = this.angularHelperService.createInterval(() => {
			if (currentRemoteVideoEnabled !== this.vm.callSettings.remoteVideoEnabled) {
				currentRemoteVideoEnabled = this.vm.callSettings.remoteVideoEnabled;
				this.handleRemoteVideoToggle(this.vm.callSettings.remoteVideoEnabled);
			}
		}, 300);
		
		if (this.browser.isMobileBrowser()) {
			this.vm.sharingDisabled = true;
		}

		this.vm.requestCall = this.requestCall;
		this.vm.hangUpCall = this.hangUpCall;
		this.vm.toggleMic = this.toggleMic;
		this.vm.toggleSound = this.toggleSound;
		this.vm.toggleVideo = this.toggleVideo;
		this.vm.shareScreen = this.shareScreen;
		this.vm.stopShareScreen = this.stopShareScreen;
		// this.vm.toggleRecording = toggleRecording;
		this.vm.closeWindow = this.closeWindow;
		this.vm.isActiveCallState = this.isActiveCallState;
		this.vm.toggleChat = this.toggleChat;
		this.vm.toggleNotes = this.toggleNotes;
		this.vm.handleCameraSwitch = this.handleCameraSwitch;
		var sessionUser = this.session.getSession();
		this.vm.origin = (sessionUser && sessionUser.user && sessionUser.user.origin) ? sessionUser.user.origin : 'minudoc.ee';
		this.vm.defaultProfilePicture = this.vm.origin == 'siffi.com'
			? 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_picture_siffi_green.png'
			: 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/defaults/default_profile_picture.png';
	}

	closeWindow() {
		window.close();
	}

	initialize() {
		this.vm.user = this.session.getSession().user || {};
		this.vm.isDoctor = this.vm.user.businessUserType === 'SERVICE_PROVIDER';
		this.vm.notes = {
			data: {}
		};
		this.vm.callEndedReasons = {
			'ENDED': this.angularFilterHelperService.translate('Call.Content.Call_Ended'),
			'HUNG_UP': this.angularFilterHelperService.translate('Call.Content.Call_Hung_Up'),
			'LOST_CONNECTION': this.angularFilterHelperService.translate('Call.Content.Call_Lost_Connection'),
			'NO_ANSWER': this.angularFilterHelperService.translate('Call.Content.Call_Not_Answered'),
			'DECLINED': this.angularFilterHelperService.translate('Call.Content.Call_Declined'),
			'ACCEPTED': this.angularFilterHelperService.translate('Call.Content.Call_Already_Accepted'),
			'USER_UNAVAILABLE': this.angularFilterHelperService.translate('Call.Content.Call_User_Unavailable')
		};

		this.vm.callState = {
			INITIAL: 'INITIAL',
			CONFIGURING: 'CONFIGURING',
			CALLING: 'CALLING',
			STARTED: 'STARTED',
			ENDED: 'ENDED'
		};
		this.vm.initialCall = true;
		this.vm.activeCallState = this.vm.callState.INITIAL;
		this.vm.setupStatus = {
			visible: true,
			message: 'Initializing call',
			detail: 'Preparing call setup'
		};
		this.vm.finalCallFailure = null;
		this.vm.finalCallFailureAlertSent = false;
		this.vm.lastIceCandidateError = null;
		this.vm.timer = new Date(0, 0);
		this.vm.callSettings = {
			localAudioEnabled: undefined,
			localVideoEnabled: undefined,
			remoteAudioEnabled: undefined,
			remoteVideoEnabled: undefined
		};

		this.vm.queuedInboundIceCandidates = [];
		this.vm.queuedOutboundIceCandidates = [];
		this.vm.handshakeComplete = false;
		this.vm.iceConnection = false;

		this.vm.outVideoBytesPrev = 0;
		this.vm.outVideoTimestampPrev = new Date().getTime();
		this.vm.outAudioBytesPrev = 0;
		this.vm.outAudioTimestampPrev = new Date().getTime();
		this.vm.inVideoBytesPrev = 0;
		this.vm.inVideoTimestampPrev = new Date().getTime();
		this.vm.inAudioBytesPrev = 0;
		this.vm.inAudioTimestampPrev = new Date().getTime();

		if (!this.validateAndFetchUrlData()) {
			this.vm.initialized = true;
			return;
		}
		this.initSignalClientConnectionAndData();
		this.vm.initialized = true;
	}

	// TODO: logic should be changed, add phone number to routeparams instead of outgoing/incoming and call instantly 
	// TODO: or answer instantly after SC has authorized
	validateAndFetchUrlData() {
		if (this.angularRoutingHelperService.getQueryParam('type')
			&& this.angularRoutingHelperService.getQueryParam('uid')
			&& ((this.angularRoutingHelperService.getQueryParam('type') === this.config.getCallConfig().CALL_TYPE.INCOMING)
				|| (this.angularRoutingHelperService.getQueryParam('type') === this.config.getCallConfig().CALL_TYPE.OUTGOING))) {
			this.vm.uid = this.angularRoutingHelperService.getQueryParam('uid');
			this.vm.callType = this.angularRoutingHelperService.getQueryParam('type');
			this.vm.bookingId = this.angularRoutingHelperService.getQueryParam('bookingId');
			this.vm.consultant = this.angularRoutingHelperService.getQueryParam('consultant');
			this.vm.callMediumType = this.angularRoutingHelperService.getQueryParam('callMediumType');
			this.vm.testCall = this.angularRoutingHelperService.getQueryParam('testCall');
			if (this.vm.isDoctor && this.vm.bookingId) {
				this.vm.notes.data.bookingId = { id: this.vm.bookingId };
				this.vm.notes.data.user = { id: this.vm.user.id };
				this.serviceRestServices.getAppointmentNotes({ bookingId: this.vm.bookingId }, (data) => {
					if (data) {
						this.vm.notes.data = data;
					}
				}, console.error);
			}
			return true;
		} else {
			var detail: any = 'Missing or invalid call type or user ID in the popup URL';
			this.logCallDebug('callUrl.invalid', {
				type: this.angularRoutingHelperService.getQueryParam('type'),
				uid: this.angularRoutingHelperService.getQueryParam('uid')
			}, 'error');
			this.updateSetupStatus('Could not initialize the call', detail, true);
			this.recordFinalCallFailure('CALL_URL_INVALID', 'Invalid call URL', detail);
			this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
			return false;
		}
	}

	initSignalClientConnectionAndData() {
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Call.AUTHENTICATED,
				() => {
					this.initCallDetails();
				})
		);

		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Call.AUTHENTICATION_FAILED,
				(event, error) => {
					var detail: any = this.getErrorDetail(error) || 'Signal server authentication failed';
					this.logCallDebug('authentication.failed', error, 'error');
					this.updateSetupStatus('Could not authenticate the call', detail, true);
					this.recordFinalCallFailure(
						'SIGNAL_AUTHENTICATION_FAILED',
						'Signal server authentication failed',
						detail,
						error);
					this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
				})
		);

		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, 'onContactUpdate', (event, parameters) => {
				if (this.vm.activeCallState === this.vm.callState.INITIAL) {
					console.info('Contact update reached in INITIAL state.');
				}

				// TODO: if contact busy or offline, change state and show info
				this.processContactDetails(parameters);
			})
		);
	}

	processContactDetails(parameters) {
		this.angularHelperService.forEach(parameters.contacts, (contact) => {

			if (parseInt(this.vm.uid) === contact.userId) {
				if (!this.vm.endpointUser) {
					this.vm.endpointUser = contact;
					this.handleOutgoingCall();
				}
				this.vm.endpointUser = contact;
			}
		});
	}

	initCallDetails() {
		if (this.vm.callType === this.config.getCallConfig().CALL_TYPE.INCOMING) {
			this.updateSetupStatus('Waiting for incoming call', 'Connected to call server');
		} else {
			this.updateSetupStatus('Preparing call', 'Loading call details');
		}
		console.info('Init call details!');
		if (this.vm.bookingId) {
			this.serviceRestServices.getCallEndpointForBooking({ bookingId: this.vm.bookingId },
				(callInfo) => {
					console.info('Start business call.', callInfo);
					this.vm.audioRecordingAllowed = this.vm.isDoctor && callInfo.bookingConsents?.audioRecordingAccepted;
					this.vm.notesAllowed = callInfo.bookingConsents?.dataProcessingAccepted
						&& callInfo.bookingConsents?.dataStorageTimeAccepted
						&& callInfo.generalConsents
						&& callInfo.generalConsents.dataStorageTimeAccepted
						&& callInfo.generalConsents.dataSharingAccepted;
					this.startBusinessCall(callInfo);
				},
				(error) => {
					this.updateSetupStatus('Could not load call details', this.getErrorDetail(error), true);
					this.recordFinalCallFailure('CALL_DETAILS_FAILED', 'Could not load booking call details', this.getErrorDetail(error), error);
					this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
					console.error(error);
				}
			);
		} else if (this.vm.consultant) {
			this.serviceRestServices.getCallEndpointForConsultant({ userId: this.vm.uid },
				(callInfo) => {
					console.info('Start business call.', callInfo);
					this.vm.audioRecordingAllowed = false;
					this.vm.notesAllowed = callInfo.bookingConsents
						&& callInfo.bookingConsents.dataProcessingAccepted
						&& callInfo.bookingConsents.dataStorageTimeAccepted
						&& callInfo.generalConsents
						&& callInfo.generalConsents.dataStorageTimeAccepted
						&& callInfo.generalConsents.dataSharingAccepted;
					this.startBusinessCall(callInfo);
				},
				(error) => {
					this.updateSetupStatus('Could not load call details', this.getErrorDetail(error), true);
					this.recordFinalCallFailure('CALL_DETAILS_FAILED', 'Could not load consultant call details', this.getErrorDetail(error), error);
					this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
					console.error(error);
				}
			);
		} else if (this.vm.testCall) {
			this.serviceRestServices.getCallEndpointForTestCall({},
				(callInfo) => {
					console.info('Start test call.');
					console.log(callInfo);
					this.startBusinessCall(callInfo);
				},
				(error) => {
					this.updateSetupStatus('Could not load call details', this.getErrorDetail(error), true);
					this.recordFinalCallFailure('CALL_DETAILS_FAILED', 'Could not load test call details', this.getErrorDetail(error), error);
					this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
					console.error(error);
				}
			);
		}
	}

	startBusinessCall(callInfo) {
		this.updateSetupStatus('Preparing call', callInfo && callInfo.endpoint ? 'Endpoint: ' + callInfo.endpoint : undefined);
		this.logCallDebug('startBusinessCall', {
			hasCallInfo: !!callInfo,
			callType: callInfo && callInfo.callType,
			endpoint: callInfo && callInfo.endpoint
		});
		if (callInfo) {
			this.vm.endpointUser = callInfo;
			this.vm.callMediumType = callInfo.callType;
			this.createDownloadNotification();
			
			this.ngZone.run(() => {
				this.vm.activeCallState = this.vm.callState.CONFIGURING;
				if (this.vm.callMediumType) this.requestCall((this.vm.callMediumType === 'AUDIO'));
			});
		} else {
			this.updateSetupStatus('Could not start the call', 'Backend returned no call endpoint information', true);
			this.recordFinalCallFailure('CALL_DETAILS_EMPTY', 'Backend returned no call endpoint information');
			this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
		}
	}

	handleRemoteVideoToggle(isShown) {
		if (typeof isShown !== 'undefined') {
			this.angularStateHelperService.setGlobalProperty('hasBgImage', !isShown);
		}
	}

	handleIncomingCall() {
		this.updateSetupStatus('Accepting call', 'Confirming incoming call');
		this.logCallDebug('handleIncomingCall', { callType: this.vm.callType });
		console.info('Handling incoming call.');
		if (this.vm.callType === this.config.getCallConfig().CALL_TYPE.INCOMING) {
			this.callService.acceptCall(
				() => {
					this.updateSetupStatus('Call accepted', 'Waiting for call setup data');
					this.time.deleteTimer(this.config.getTimerConfig().Call.REQUEST_DISCONNECTED);
					console.info('successfully accepted call.');
				},
				() => {
					this.updateSetupStatus('Could not accept the call', 'Call server rejected the accept request', true);
					this.recordFinalCallFailure('CALL_ACCEPT_FAILED', 'Could not accept the incoming call', 'Call server rejected the accept request');
					this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
					console.error('failed to accept call.');
				}
			);
		}
	}

	handleOutgoingCall() {
		console.info('Handling outgoing call.');
		if (this.vm.callType === this.config.getCallConfig().CALL_TYPE.OUTGOING) {
			this.ngZone.run(() => {
				this.vm.activeCallState = this.vm.callState.CONFIGURING;
			});
		}
	}

	requestCall(audioOnly) {
		this.vm.audioOnly = this.toBoolean(audioOnly);
		this.updateSetupStatus('Sending call request', this.vm.endpointUser && this.vm.endpointUser.endpoint ? 'Endpoint: ' + this.vm.endpointUser.endpoint : undefined);
		this.logCallDebug('requestCall.start', {
			endpoint: this.vm.endpointUser && this.vm.endpointUser.endpoint,
			audioOnly: this.vm.audioOnly,
			activeCallState: this.vm.activeCallState
		});

		this.callService.requestCall(this.vm.endpointUser.endpoint, this.vm.audioOnly,
			() => {
				this.updateSetupStatus('Waiting for answer', 'The other participant has been notified');
				this.logCallDebug('requestCall.success');
				this.ngZone.run(() => {
					this.vm.activeCallState = this.vm.callState.CALLING;
					this.callService.startWaitingSound();
				});

				this.callService.startWaitingSound();

				this.time.newTimer(this.config.getTimerConfig().Call.REQUEST_DISCONNECTED, () => {
					this.callService.stopWaitingSound();
					this.time.deleteTimer(this.config.getTimerConfig().Call.REQUEST_DISCONNECTED);
					this.updateSetupStatus('The other participant did not answer', 'Call request timed out', true);
					this.finishCall(this.vm.callEndedReasons.NO_ANSWER);
					console.info('CallModule.RequestCall.RequestDisconnectedTimer');
				}, this.config.getCallConfig().CALLING_TIMEOUT);

			},
			(error) => {
				this.logCallDebug('requestCall.error', error, 'error');
				this.updateSetupStatus(
					error && error.code === 'E_USER_UNAVAILABLE' ? 'User is unavailable' : 'Could not start the call',
					this.getErrorDetail(error),
					true);
				this.recordFinalCallFailure(
					error && error.code === 'E_USER_UNAVAILABLE' ? 'CALL_USER_UNAVAILABLE' : 'CALL_REQUEST_FAILED',
					error && error.code === 'E_USER_UNAVAILABLE' ? 'User is unavailable' : 'Could not start the call',
					this.getErrorDetail(error),
					error);
				this.finishCall(error && error.code === 'E_USER_UNAVAILABLE'
					? this.vm.callEndedReasons.USER_UNAVAILABLE
					: this.vm.callEndedReasons.LOST_CONNECTION);
				console.error('failed to request a call.', error);
			}
		);
	}

	hangUpCall(isOriginator) {
		this.callService.hangUpCall(isOriginator
			? this.config.getCallConfig().HANGUP_DETAIL.ORIGINATOR_CANCEL
			: this.config.getCallConfig().HANGUP_DETAIL.NORMAL_CLEARING);
		this.finishCall(this.vm.callEndedReasons.ENDED);
	}

	forceEndCall(reason, detail) {
		if (this.vm.activeCallState === this.vm.callState.ENDED) return;
		if (!this.vm.finalCallFailure && reason === this.vm.callEndedReasons.LOST_CONNECTION) {
			this.recordFinalCallFailure('CALL_FORCE_ENDED', 'Call was force-ended because connection was lost', detail);
		}
		this.callService.hangUpCall(detail);
		this.finishCall(reason);
	}

	toggleMic() {
		this.vm.callSettings.localAudioEnabled = !this.vm.callSettings.localAudioEnabled;
		var audioTrack: any = this.vm.localStream && this.vm.localStream.getAudioTracks()[0];
		if (audioTrack) {
			audioTrack.enabled = this.vm.callSettings.localAudioEnabled;
		}
	}

	toggleSound() {
		this.vm.callSettings.remoteAudioEnabled = !this.vm.callSettings.remoteAudioEnabled;
		var audioTrack: any = this.vm.remoteStream && this.vm.remoteStream.getAudioTracks()[0];
		if (audioTrack) {
			audioTrack.enabled = this.vm.callSettings.remoteAudioEnabled;
		}
	}

	toggleVideo() {
		console.log('Toggle video', this.vm.devices);
		this.vm.callSettings.localVideoEnabled = !this.vm.callSettings.localVideoEnabled;
		var videoTrack: any = this.vm.localStream && this.vm.localStream.getVideoTracks()[0];
		if (videoTrack) {
			videoTrack.enabled = this.vm.callSettings.localVideoEnabled;
			this.callService.rtcCustom({ mediaStateChange: { 'VIDEO': this.vm.callSettings.localVideoEnabled } });
		}
	}

	isActiveCallState(state) {
		return this.vm.activeCallState === state;
	}

	handleConnectionStateChange(event, newConnectionState) {
		this.logCallDebug('signalConnectionState', { newConnectionState: newConnectionState });
		switch (newConnectionState) {
			case 'TRYING_TO_CONNECT':
				this.updateSetupStatus('Connecting to call server', 'Opening secure signaling connection');
				// forceEndCall(HangupDetail.SIGNAL_CLIENT_CONNECTION_LOST, this.config.getCallConfig().ICE_CONNECTION_TIMEOUT);
				break;
			case 'CONNECTED':
				this.updateSetupStatus('Authenticating call session', 'Connected to call server');
				break;
			case 'DISCONNECTED':
				this.updateSetupStatus('Call server connection was lost', 'Signaling connection disconnected', true);
				this.recordFinalCallFailure('SIGNAL_CONNECTION_FAILED', 'Call server connection was lost', 'Signaling connection disconnected');
				this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
				break;
			default:
				console.error('ERROR: Unhandled connection state - ' + newConnectionState + '.');
		}
	}

	handleMediaStateChange(event, parameters) {
		for (var mediaState in parameters) {
			switch (mediaState) {
				case this.config.getCallConfig().MEDIA_STATE_TYPE.VIDEO:
					this.vm.callSettings.remoteVideoEnabled = parameters.VIDEO;
					break;
				case this.config.getCallConfig().MEDIA_STATE_TYPE.HOLD:
					this.vm.callSettings.remoteVideoEnabled = parameters.HOLD;
					break;
				default:
					console.error('ERROR: Unhandled rtcCustom mediaStateChange - ' + parameters + '.');
			}
		}
	}

	handleRequestCall(event, parameters) {
		this.updateSetupStatus('Incoming call received', parameters && parameters.user ? parameters.user.firstName + ' ' + parameters.user.lastName : undefined);
		this.logCallDebug('incomingRequestCall', parameters);
		this.vm.endpointUser = parameters.user;
		this.vm.audioOnly = this.toBoolean(parameters.audioOnly);

		this.time.newTimer(this.config.getTimerConfig().Call.REQUEST_DISCONNECTED, () => {
			console.info('CallModule.OnRequestCall.RequestDisconnectedTimer');
			this.time.deleteTimer(this.config.getTimerConfig().Call.REQUEST_DISCONNECTED);
			this.updateSetupStatus('Call setup timed out', 'Incoming call setup did not complete', true);
			this.recordFinalCallFailure('CALL_SETUP_TIMEOUT', 'Incoming call setup timed out', 'No RTC setup was received before timeout');
			this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
		}, this.config.getCallConfig().CALLING_TIMEOUT);

		if (this.vm.initialCall) {
			this.vm.initialCall = false;
			this.handleIncomingCall();
		} else {
			var detail: any = 'A second incoming call request was received by the active call popup';
			this.logCallDebug('incomingRequestCall.duplicate', parameters, 'error');
			this.updateSetupStatus('Duplicate incoming call request', detail, true);
			this.recordFinalCallFailure('CALL_REQUEST_DUPLICATE', 'Duplicate incoming call request', detail, parameters);
			this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
		}
	}

	handleOnCallAccepted() {
		this.updateSetupStatus('Call accepted', 'Creating secure media connection');
		this.logCallDebug('callAccepted', {
			audioOnly: this.vm.audioOnly,
			activeCallState: this.vm.activeCallState
		});
		this.callService.stopWaitingSound();
		this.statusService.setStatus(this.vm.endpointUser.userId, 'BUSY');
		this.vm.activeCallState = this.vm.callState.STARTED;
		this.time.deleteTimer(this.config.getTimerConfig().Call.REQUEST_DISCONNECTED);
		this.vm.peerConnection = this.createPeerConnection();
		this.initTimer();

		this.initLocalMedia(this.vm.audioOnly, this.vm.peerConnection,
			() => {
				this.createAndSendOffer(this.vm.peerConnection);
			},
			() => {
				this.createAndSendOffer(this.vm.peerConnection);
			}
		);
	}

	handleOnCallEnded(event, callResolution) {
		if (this.vm.callEndedReasons[callResolution.code]) {
			this.finishCall(this.vm.callEndedReasons[callResolution.code]);
		} else {
			this.finishCall(this.vm.callEndedReasons.ENDED);
		}
	}

	handleOnRtcOffer(event, offer) {
		this.updateSetupStatus('Receiving call offer', 'Processing remote media setup');
		this.logCallDebug('rtcOffer.received', {
			type: offer && offer.type,
			sdpLength: offer && offer.sdp && offer.sdp.length
		});
		this.handleIncomingOffer(offer);
	}

	handleOnRtcAnswer(event, answer) {
		this.updateSetupStatus('Receiving call answer', 'Applying remote media setup');
		this.logCallDebug('rtcAnswer.received', {
			type: answer && answer.type,
			sdpLength: answer && answer.sdp && answer.sdp.length
		});
		this.vm.peerConnection.setRemoteDescription(new RTCSessionDescription(answer))
			.then(() => {
				this.updateSetupStatus('Finding network route', 'Exchanging network candidates');
				this.logCallDebug('rtcAnswer.setRemoteDescription.success');
				this.vm.handshakeComplete = true;
				this.drainInboundIceCandidates();
				this.drainOutboundIceCandidates();
			})
			.catch((error) => {
				this.updateSetupStatus('Could not process the remote call setup', this.getErrorDetail(error), true);
				this.recordFinalCallFailure('RTC_ANSWER_PROCESS_FAILED', 'Could not process the remote call answer', this.getErrorDetail(error), error);
				this.logCallDebug('rtcAnswer.setRemoteDescription.error', error, 'error');
				console.error('onRtcAnswerError : ' + error);
				this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
			});
	}

	handleOnRtcIceCandidate(event, iceCandidate) {
		this.logCallDebug('iceCandidate.received', {
			hasCandidate: !!iceCandidate,
			handshakeComplete: this.vm.handshakeComplete
		});
		this.vm.queuedInboundIceCandidates.push(iceCandidate);
		this.drainInboundIceCandidates();
	}

	handleIncomingOffer(offer) {
		this.updateSetupStatus('Receiving call offer', 'Preparing local media');
		this.logCallDebug('incomingOffer.start', {
			audioOnly: this.vm.audioOnly,
			hasPeerConnection: !!this.vm.peerConnection
		});
		this.ngZone.run(() => {
			this.vm.activeCallState = this.vm.callState.STARTED;
		});
		if (!this.vm.peerConnection) this.vm.peerConnection = this.createPeerConnection();
		if (!this.time.getTimer(this.config.getTimerConfig().Call.CALLING_TIMER)) this.initTimer();

		this.initLocalMedia(this.vm.audioOnly, this.vm.peerConnection,
			() => {
				this.createAndSendAnswer(this.vm.peerConnection, offer);
			},
			() => {
				this.createAndSendAnswer(this.vm.peerConnection, offer);
			}
		);
	}

	initTimer() {
		this.time.newTimer(this.config.getTimerConfig().Call.CALLING_TIMER, () => {
			this.vm.timer.setSeconds(this.vm.timer.getSeconds() + 1);
			if (this.vm.timer.getHours() >= 1) {
				this.vm.formattedTimer = this.angularFilterHelperService.formatDate(this.vm.timer, 'H:mm:ss');
			} else {
				this.vm.formattedTimer = this.angularFilterHelperService.formatDate(this.vm.timer, 'm:ss');
			}
			if (this.vm.peerConnection) {
				this.analyzeNetworkStatus();
			}

			// this.angularStateHelperService.scopeApply(this); // TODO ANGULAR_2 whats the purpose of this line?
		}, 1000);
	}

	analyzeNetworkStatus() {
		if (this.vm.networkAnalyzeInProcess) return;
		this.vm.networkAnalyzeInProcess = true;
		this.vm.peerConnection.getStats()
			.then((stats) => {
				stats.forEach((stat) => {
					if (stat.type === 'outbound-rtp' && (stat.mediaType === 'video' || stat.id.includes('VideoStream'))) {
						if (this.vm.outVideoTimestampPrev) {
							this.vm.outVideoBitrate = (8 * (stat.bytesSent - this.vm.outVideoBytesPrev)
								/ (stat.timestamp - this.vm.outVideoTimestampPrev)) | 0;
						}
						this.vm.outVideoBytesPrev = stat.bytesSent;
						this.vm.outVideoTimestampPrev = stat.timestamp;
					}
					if (stat.type === 'outbound-rtp' && (stat.mediaType === 'audio' || stat.id.includes('AudioStream'))) {
						if (this.vm.outAudioTimestampPrev) {
							this.vm.outAudioBitrate = (8 * (stat.bytesSent - this.vm.outAudioBytesPrev)
								/ (stat.timestamp - this.vm.outAudioTimestampPrev)) | 0;
						}
						this.vm.outAudioBytesPrev = stat.bytesSent;
						this.vm.outAudioTimestampPrev = stat.timestamp;
					}

					if (stat.type === 'inbound-rtp' && (stat.mediaType === 'video' || stat.id.includes('VideoStream'))) {
						if (this.vm.inVideoTimestampPrev) {
							this.vm.inVideoBitrate = (8 * (stat.bytesReceived - this.vm.inVideoBytesPrev)
								/ (stat.timestamp - this.vm.inVideoTimestampPrev)) | 0;
						}
						this.vm.inVideoBytesPrev = stat.bytesReceived;
						this.vm.inVideoTimestampPrev = stat.timestamp;
					}
					if (stat.type === 'inbound-rtp' && (stat.mediaType === 'audio' || stat.id.includes('AudioStream'))) {
						if (this.vm.inAudioTimestampPrev) {
							this.vm.inAudioBitrate = (8 * (stat.bytesReceived - this.vm.inAudioBytesPrev)
								/ (stat.timestamp - this.vm.inAudioTimestampPrev)) | 0;
						}
						this.vm.inAudioBytesPrev = stat.bytesReceived;
						this.vm.inAudioTimestampPrev = stat.timestamp;
					}
				});
				this.displayNetworkStatus();
				this.vm.networkAnalyzeInProcess = false;
			}).catch((error) => {
				console.log(error);
				this.vm.networkAnalyzeInProcess = false;
			});
	}

	displayNetworkStatus() {
		var localNetworkStatus: any = document.getElementById('localNetworkStatus');
		if (localNetworkStatus) {
			if (this.vm.outVideoBitrate && this.vm.outAudioBitrate) {
				var bitrateOut: any = this.vm.outVideoBitrate + this.vm.outAudioBitrate;
				localNetworkStatus.style.visibility = 'visible';
				if (bitrateOut > 450) {
					this.replaceSignalIcon(localNetworkStatus, 'o-icon--signal-3');
				} else if (bitrateOut > 300) {
					this.replaceSignalIcon(localNetworkStatus, 'o-icon--signal-2');
				} else {
					this.replaceSignalIcon(localNetworkStatus, 'o-icon--signal-1');
				}
			} else {
				localNetworkStatus.style.visibility = 'hidden';
				this.replaceSignalIcon(localNetworkStatus, 'o-icon--signal-0');
			}
		}

		var remoteNetworkStatus: any = document.getElementById('remoteNetworkStatus');
		if (remoteNetworkStatus) {
			if (this.vm.inVideoBitrate && this.vm.inAudioBitrate) {
				var bitrateIn: any = this.vm.inVideoBitrate + this.vm.inAudioBitrate;
				remoteNetworkStatus.style.visibility = 'visible';
				if (bitrateIn > 450) {
					this.replaceSignalIcon(remoteNetworkStatus, 'o-icon--signal-3');
				} else if (bitrateIn > 300) {
					this.replaceSignalIcon(remoteNetworkStatus, 'o-icon--signal-2');
				} else {
					this.replaceSignalIcon(remoteNetworkStatus, 'o-icon--signal-1');
				}
			} else {
				if (this.isAudioOnlyCall()) {
					remoteNetworkStatus.style.visibility = 'hidden';
				}
				this.replaceSignalIcon(remoteNetworkStatus, 'o-icon--signal-0');
			}
		}
	}

	replaceSignalIcon(signalIconElement, newIconClass) {
		signalIconElement.classList.remove('o-icon--signal-0');
		signalIconElement.classList.remove('o-icon--signal-1');
		signalIconElement.classList.remove('o-icon--signal-2');
		signalIconElement.classList.remove('o-icon--signal-3');

		signalIconElement.classList.add(newIconClass);
	}

	createPeerConnection() {
		var iceServers: any = {
			iceServers: [{
				urls: [
					'stun:turn1.sentab.com:443',
					'turn:turn1.sentab.com:443?transport=udp',
					'turn:turn1.sentab.com:443?transport=tcp',
					'turns:turn1.sentab.com:443?transport=tcp'
				],
				username: 'turnuser',
				credential: 'to6vRbvhGs'
			}]
		};
		var pcConstraints: any = { mandatory: {}, optional: [{ DtlsSrtpKeyAgreement: true }] };
		var peerConnection: any = new RTCPeerConnection(iceServers/**, pcConstraints*//** TODO ANGULAR_2:VALIDATE removal not breaking anything*/);
		peerConnection.ontrack = (evt) => { this.handlePeerConnectionOnTrack(evt) };
		peerConnection.onicecandidate = (evt) => { this.handlePeerConnectionOnIceCandidate(evt) };
		peerConnection.onicecandidateerror = (evt) => { this.handlePeerConnectionOnIceCandidateError(evt) };
		peerConnection.oniceconnectionstatechange = (evt) => { this.handlePeerConnectionOnIceConnectionStateChange(evt) };

		return peerConnection;
	}

	handlePeerConnectionOnIceCandidate(evt) {
		if (evt.candidate) {
			this.logCallDebug('iceCandidate.local', {
				type: this.getIceCandidateType(evt.candidate.candidate),
				sdpMid: evt.candidate.sdpMid,
				sdpMLineIndex: evt.candidate.sdpMLineIndex,
				handshakeComplete: this.vm.handshakeComplete
			});
			this.vm.queuedOutboundIceCandidates.push({
				sdpMid: evt.candidate.sdpMid,
				sdpMLineIndex: evt.candidate.sdpMLineIndex,
				candidate: evt.candidate.candidate
			});
			this.drainOutboundIceCandidates();
		} else {
			this.logCallDebug('iceCandidate.gatheringComplete');
		}
	}

	handlePeerConnectionOnIceCandidateError(evt) {
		var url: string = evt && evt.url || '';
		var serverType: string = url.indexOf('turn') === 0 ? 'TURN' : 'STUN';
		var detailParts: any = [];

		if (evt && evt.errorCode) detailParts.push('code ' + evt.errorCode);
		if (evt && evt.errorText) detailParts.push(evt.errorText);
		if (url) detailParts.push(url);
		if (evt && evt.address) detailParts.push(evt.address + (evt.port ? ':' + evt.port : ''));
		this.vm.lastIceCandidateError = {
			url: url,
			address: evt && evt.address,
			port: evt && evt.port,
			errorCode: evt && evt.errorCode,
			errorText: evt && evt.errorText,
			serverType: serverType
		};

		this.logCallDebug('iceCandidate.error', {
			url: url,
			address: evt && evt.address,
			port: evt && evt.port,
			errorCode: evt && evt.errorCode,
			errorText: evt && evt.errorText,
			serverType: serverType,
			connectionEstablished: this.vm.connectionEstablished
		});

		if (!this.vm.connectionEstablished && (!this.vm.setupStatus || !this.vm.setupStatus.isError)) {
			this.updateSetupStatus(
				serverType + ' server check failed',
				detailParts.length ? detailParts.join(' | ') : 'Browser could not gather this network candidate');
		}
	}

	handlePeerConnectionOnTrack(evt) {
		console.log('on track: ', evt);
		if (this.vm.remoteStream !== evt.streams[0]) {
			this.vm.remoteStream = evt.streams[0];
			//var streamEl1: any = $('#remoteVideo'); // TODO ANGULAR_2:VALIDATE
			var streamEl1: HTMLVideoElement = document.getElementById('remoteVideo') as HTMLVideoElement;
			streamEl1.srcObject = this.vm.remoteStream;
			// var targetEl: any = document.getElementById('remoteVideo');
			if (streamEl1) {
				streamEl1.muted = false;
			}
		}

		if (evt.track.kind === 'video') {
			this.vm.callSettings.remoteVideoEnabled = typeof this.vm.callSettings.remoteVideoEnabled === 'undefined'
				? true
				: this.vm.callSettings.remoteVideoEnabled;
		} else if (evt.track.kind === 'audio') {
			this.vm.callSettings.remoteAudioEnabled = typeof this.vm.callSettings.remoteAudioEnabled === 'undefined'
				? true
				: this.vm.callSettings.remoteAudioEnabled;
			if (this.vm.audioRecordingAllowed
				&& this.vm.callType === this.config.getCallConfig().CALL_TYPE.OUTGOING
				&& this.initAudioRecording()) {
				setTimeout(() => {
					this.startRecording();
					this.vm.audioRecordingEnabled = true;
				}, 1000); // TODO: find out an event to indicate it's safe to start recording
				this.vm.callStartTime = new Date();
			}
		}
	}

	handlePeerConnectionOnIceConnectionStateChange(evt) {
		this.logCallDebug('iceConnectionState', {
			state: evt.currentTarget.iceConnectionState,
			connectionEstablished: this.vm.connectionEstablished
		});
		switch (evt.currentTarget.iceConnectionState) {
			case 'connected':
				this.vm.iceConnection = true;
				this.vm.connectionEstablished = true;
				this.clearSetupStatus();
				this.time.deleteTimer(this.config.getTimerConfig().Call.CALL_DISCONNECTED);
				break;
			case 'completed':
				this.vm.iceConnection = true;
				this.vm.connectionEstablished = true;
				this.clearSetupStatus();
				this.time.deleteTimer(this.config.getTimerConfig().Call.CALL_DISCONNECTED);
				break;
			case 'disconnected':
				this.vm.iceConnection = false;
				this.updateSetupStatus('Media connection interrupted', 'Trying to recover the network route');
				this.time.newTimer(this.config.getTimerConfig().Call.CALL_DISCONNECTED, () => {
					var peerConnection: any = this.vm.peerConnection;
					if (peerConnection
						&& this.vm.activeCallState !== this.vm.callState.ENDED
						&& (peerConnection.iceConnectionState === 'disconnected'
							|| peerConnection.iceConnectionState === 'failed')) {
						this.updateSetupStatus('Could not find a network route for media', 'ICE connection timed out', true);
						this.recordFinalCallFailure('RTC_ICE_FAILED', 'Could not find a network route for media', 'ICE connection timed out', {
							iceConnectionState: peerConnection.iceConnectionState,
							lastIceCandidateError: this.vm.lastIceCandidateError
						});
						this.forceEndCall(
							this.vm.callEndedReasons.LOST_CONNECTION,
							this.config.getCallConfig().HANGUP_DETAIL.ICE_CONNECTION_LOST);
					}
					console.info('CallModule.OnIceConnectionStateChange.CallDisconnectedTimer');
				}, this.config.getCallConfig().ICE_CONNTECTION_TIMEOUT);
				break;
			case 'failed':
				console.error('Failed to create ice connection!');
				this.vm.iceConnection = false;
				this.time.deleteTimer(this.config.getTimerConfig().Call.CALL_DISCONNECTED);
				this.updateSetupStatus('Could not find a network route for media', 'ICE connection failed', true);
				this.recordFinalCallFailure('RTC_ICE_FAILED', 'Could not find a network route for media', 'ICE connection failed', {
					iceConnectionState: evt.currentTarget.iceConnectionState,
					lastIceCandidateError: this.vm.lastIceCandidateError
				});
				this.forceEndCall(
					this.vm.callEndedReasons.LOST_CONNECTION,
					this.config.getCallConfig().HANGUP_DETAIL.ICE_CONNECTION_LOST);
				break;
			case 'closed':
				this.vm.iceConnection = false;
				this.time.deleteTimer(this.config.getTimerConfig().Call.CALL_DISCONNECTED);
				break;
			default:
		}
	}

	getMediaPermissions() {
		var defer: any = this.angularHelperService.getDeferredPromise();
		var audioOnly: any = this.isAudioOnlyCall();
		this.updateSetupStatus('Checking camera and microphone permissions', 'Waiting for browser permission');
		this.logCallDebug('mediaPermissions.request', { audio: true, video: !audioOnly, audioOnly: audioOnly });
		
		navigator.mediaDevices.getUserMedia({ audio: true, video: !audioOnly })
			.then(() => {
				this.logCallDebug('mediaPermissions.success');
				defer.resolve();
			})
			.catch((error) => {
				this.updateSetupStatus('Checking camera and microphone permissions', this.getErrorDetail(error));
				this.logCallDebug('mediaPermissions.error', {
					name: error && error.name,
					message: error && error.message
				}, 'error');
				defer.resolve();
			});

		return defer.promise;
	}

	initLocalMedia(audioOnly, peerConnection, successCallback, errorCallback) {
		this.vm.audioOnly = this.toBoolean(audioOnly);
		this.updateSetupStatus('Detecting media devices', 'Looking for camera and microphone');
		this.logCallDebug('initLocalMedia.start', { audioOnly: this.vm.audioOnly });
		this.getMediaPermissions()
		    .then(() => navigator.mediaDevices.enumerateDevices())
			.then((devices) => {
				this.logCallDebug('enumerateDevices.success', {
					total: devices && devices.length,
					audioInputs: devices && devices.filter((device) => device.kind === 'audioinput').length,
					videoInputs: devices && devices.filter((device) => device.kind === 'videoinput').length
				});
				console.log('Got devices: ', devices);
				var audioDeviceLabel: any = localStorage.getItem('_aid'),
					videoDeviceLabel = localStorage.getItem('_vid');
				this.vm.devices = devices;
				this.vm.audioDevices = devices.map((device) => { if (device.kind === 'audioinput') return device; return null; })
					.filter((device) => { return device && device.deviceId; });
				this.vm.videoDevices = devices.map((device) => { if (device.kind === 'videoinput') return device; return null; })
					.filter((device) => { return device && device.deviceId; });
				this.vm.hasAudioDevices = !!this.vm.audioDevices.length;
				this.vm.hasVideoDevices = !!this.vm.videoDevices.length;
				console.log('Audio devices', this.vm.audioDevices);
				console.log('Video devices', this.vm.videoDevices);
				this.vm.mediaConstraints = {};

				if (this.vm.hasAudioDevices) {
					var chosenAudioDevice: any = this.vm.audioDevices.filter((audioDevice) => {
						return audioDevice.label === audioDeviceLabel;
					})[0];
					this.vm.mediaConstraints.audio = {
						deviceId: {
							exact: chosenAudioDevice ? chosenAudioDevice.deviceId : this.vm.audioDevices[0].deviceId
						}
					};
				} else {
					this.vm.mediaConstraints.audio = false;
				}

				if (this.vm.hasVideoDevices && !this.isAudioOnlyCall()) {
					var chosenVideoDevice: any = this.vm.videoDevices.filter((videoDevice) => {
						return videoDevice.label === videoDeviceLabel;
					})[0];
					this.vm.mediaConstraints.video = {
						width: { ideal: 1920 },
						height: { ideal: 1080 },
						aspectRatio: { ideal: 1.7777777778 },
						deviceId: { exact: chosenVideoDevice ? chosenVideoDevice.deviceId : this.vm.videoDevices[0].deviceId }
					};
				} else {
					this.vm.mediaConstraints.video = false;
				}

				if (!this.validateRequiredMediaDevices()) return;

				this.handleMediaInit()
					.then(() => {
						if (!this.validateRequiredMediaTracks()) return;
						this.updateSetupStatus('Starting camera and microphone', 'Local media is ready');
						this.logCallDebug('handleMediaInit.success', {
							audioTracks: this.vm.localStream && this.vm.localStream.getAudioTracks().length,
							videoTracks: this.vm.localStream && this.vm.localStream.getVideoTracks().length
						});
						this.handleMissingDevices();
						successCallback();
					})
					.catch((mediaInitError) => {
						this.updateSetupStatus(this.getMediaErrorMessage(mediaInitError), this.getErrorDetail(mediaInitError), true);
						this.recordFinalCallFailure('LOCAL_MEDIA_FAILED', this.getMediaErrorMessage(mediaInitError), this.getErrorDetail(mediaInitError), mediaInitError);
						this.logCallDebug('handleMediaInit.error', {
							name: mediaInitError && mediaInitError.name,
							message: mediaInitError && mediaInitError.message
						}, 'error');
						this.handleMissingDevices(mediaInitError);
						this.forceEndCall(
							this.vm.callEndedReasons.LOST_CONNECTION,
							this.config.getCallConfig().HANGUP_DETAIL.ICE_CONNECTION_LOST);
					});
			})
			.catch((error) => {
				this.updateSetupStatus('Could not detect media devices', this.getErrorDetail(error), true);
				this.recordFinalCallFailure('MEDIA_DEVICE_ENUMERATION_FAILED', 'Could not detect media devices', this.getErrorDetail(error), error);
				this.logCallDebug('enumerateDevices.error', error, 'error');
				console.error(error);
				this.vm.callSettings.localAudioEnabled = false;
				this.vm.callSettings.localVideoEnabled = false;
				this.forceEndCall(
					this.vm.callEndedReasons.LOST_CONNECTION,
					this.config.getCallConfig().HANGUP_DETAIL.ICE_CONNECTION_LOST);
			});
	}

	validateRequiredMediaDevices() {
		this.logCallDebug('mediaDevices.requiredCheck', {
			audioOnly: this.vm.audioOnly,
			isAudioOnlyCall: this.isAudioOnlyCall(),
			hasAudioDevices: this.vm.hasAudioDevices,
			hasVideoDevices: this.vm.hasVideoDevices,
			requiresVideo: !this.isAudioOnlyCall(),
			audioConstraint: !!this.vm.mediaConstraints.audio,
			videoConstraint: !!this.vm.mediaConstraints.video
		});

		if (!this.vm.mediaConstraints.audio) {
			this.updateSetupStatus('No microphone was found', 'A microphone is required to start the call', true);
			this.recordFinalCallFailure('LOCAL_MICROPHONE_MISSING', 'No microphone was found', 'A microphone is required to start the call', {
				audioDevices: this.vm.audioDevices && this.vm.audioDevices.length || 0,
				videoDevices: this.vm.videoDevices && this.vm.videoDevices.length || 0,
				audioOnly: this.vm.audioOnly
			});
			this.handleMissingDevices();
			this.forceEndCall(
				this.vm.callEndedReasons.LOST_CONNECTION,
				this.config.getCallConfig().HANGUP_DETAIL.ICE_CONNECTION_LOST);
			return false;
		}

		if (!this.isAudioOnlyCall() && !this.vm.mediaConstraints.video) {
			this.updateSetupStatus('No camera was found', 'A camera is required to start this video call', true);
			this.recordFinalCallFailure('LOCAL_CAMERA_MISSING', 'No camera was found', 'A camera is required to start this video call', {
				audioDevices: this.vm.audioDevices && this.vm.audioDevices.length || 0,
				videoDevices: this.vm.videoDevices && this.vm.videoDevices.length || 0,
				audioOnly: this.vm.audioOnly
			});
			this.handleMissingDevices();
			this.forceEndCall(
				this.vm.callEndedReasons.LOST_CONNECTION,
				this.config.getCallConfig().HANGUP_DETAIL.ICE_CONNECTION_LOST);
			return false;
		}

		return true;
	}

	validateRequiredMediaTracks() {
		var audioTracks: any = this.vm.localStream && this.vm.localStream.getAudioTracks ? this.vm.localStream.getAudioTracks() : [];
		var videoTracks: any = this.vm.localStream && this.vm.localStream.getVideoTracks ? this.vm.localStream.getVideoTracks() : [];
		this.logCallDebug('mediaTracks.requiredCheck', {
			audioOnly: this.vm.audioOnly,
			isAudioOnlyCall: this.isAudioOnlyCall(),
			audioTracks: audioTracks.length,
			videoTracks: videoTracks.length,
			requiresVideo: !this.isAudioOnlyCall()
		});

		if (!audioTracks.length) {
			this.updateSetupStatus('Microphone could not start', 'Browser returned no microphone track', true);
			this.recordFinalCallFailure('LOCAL_MICROPHONE_TRACK_MISSING', 'Microphone could not start', 'Browser returned no microphone track');
			this.handleMissingDevices();
			this.forceEndCall(
				this.vm.callEndedReasons.LOST_CONNECTION,
				this.config.getCallConfig().HANGUP_DETAIL.ICE_CONNECTION_LOST);
			return false;
		}

		if (!this.isAudioOnlyCall() && !videoTracks.length) {
			this.updateSetupStatus('Camera could not start', 'Browser returned no camera track', true);
			this.recordFinalCallFailure('LOCAL_CAMERA_TRACK_MISSING', 'Camera could not start', 'Browser returned no camera track');
			this.handleMissingDevices();
			this.forceEndCall(
				this.vm.callEndedReasons.LOST_CONNECTION,
				this.config.getCallConfig().HANGUP_DETAIL.ICE_CONNECTION_LOST);
			return false;
		}

		return true;
	}

	toBoolean(value) {
		return value === true || value === 'true';
	}

	isAudioOnlyCall() {
		return this.toBoolean(this.vm && this.vm.audioOnly);
	}

	handleMissingDevices(mediaInitError?) {
		var hasRequestedDevices: any = this.vm.mediaConstraints.audio && (this.isAudioOnlyCall() || this.vm.mediaConstraints.video);
		var hasNotAllowedError: any = mediaInitError && mediaInitError.name == 'NotAllowedError';
		if (hasRequestedDevices && !hasNotAllowedError) return;

		var avTestUrl: any = this.urlUtil.createAvTestUrl();

		this.vm.devicesMissing = true;
		this.vm.devicesMissingText = this.angularFilterHelperService.translate('Call.Devices_Missing')
			.replace('{a}', '<a href="' + avTestUrl + '"" target="_blank" rel="noopener noreferrer" style="color:#fff;text-decoration:underline">')
			.replace('{/a}', '</a>');

		var devicesMissingMessage: any = this.angularFilterHelperService.translate('Call.Devices_Missing_Message')
			.replace('%s', this.vm.user.firstname + ' ' + this.vm.user.lastname);
		this.chatRestServices.sendTextMessage({ forUser: this.vm.endpointUser.userId }, { contentType: 'TEXT', content: devicesMissingMessage });
	}

	handleCameraSwitch() {
		if (!this.vm.mediaConstraints || !this.vm.videoDevices || !this.vm.videoDevices.length || this.vm.videoDevices.length === 1) return;

		var currentCameraIndex: any = -1;
		var currentCameraId: any = this.vm.mediaConstraints.video.deviceId
			&& this.vm.mediaConstraints.video.deviceId.exact || this.vm.videoDevices[0].deviceId;
		for (var i = 0, len = this.vm.videoDevices.length; i < len; i++) {
			if (this.vm.videoDevices[i].deviceId === currentCameraId) {
				currentCameraIndex = i;
				break;
			}
		}

		var nextCameraIndex: any = -1;
		if (currentCameraIndex !== -1 && currentCameraIndex < this.vm.videoDevices.length - 1) {
			nextCameraIndex = currentCameraIndex + 1;
		} else {
			nextCameraIndex = 0;
		}
		var nextCameraId: any = nextCameraIndex !== -1 ? this.vm.videoDevices[nextCameraIndex].deviceId : undefined;
		if (!nextCameraId) return;

		// this.vm.facingMode = this.vm.facingMode === 'user' ? 'environment' : 'user';
		// this.vm.mediaConstraints.video.facingMode = this.vm.facingMode;
		this.vm.mediaConstraints.video.deviceId = { exact: nextCameraId };

		if (this.vm.localStream) {
			this.vm.localStream.getTracks().forEach((track) => {
				track.stop();
			});
		}

		navigator.mediaDevices.getUserMedia(this.vm.mediaConstraints)
			.then((localStream) => {
				this.vm.localStream = localStream;

				localStream.getTracks().forEach((track) => {
					this.vm.peerConnectionSenders.forEach((sender) => {
						if (sender.track.kind == track.kind) {
							sender.replaceTrack(track);
						}
					});
				});

				this.vm.callSettings.localAudioEnabled = typeof this.vm.callSettings.localAudioEnabled === 'undefined'
					? localStream.getAudioTracks().length > 0
					: this.vm.callSettings.localAudioEnabled;
				this.vm.callSettings.localVideoEnabled = typeof this.vm.callSettings.localVideoEnabled === 'undefined'
					? localStream.getVideoTracks().length > 0
					: this.vm.callSettings.localVideoEnabled;

				//var streamEl2: any = $('#localVideo'); // TODO ANGULAR_2:VALIDATE
				var streamEl2: HTMLVideoElement = document.getElementById('localVideo') as HTMLVideoElement;
				streamEl2.srcObject = localStream;
				//var targetVidEl: any = document.getElementById('localVideo');
				if (streamEl2) {
					streamEl2.muted = true;
				}
			})
			.catch((error) => {
				console.error(error.message);
				this.vm.callSettings.localAudioEnabled = typeof this.vm.callSettings.localAudioEnabled === 'undefined'
					? false
					: this.vm.callSettings.localAudioEnabled;
				this.vm.callSettings.localVideoEnabled = typeof this.vm.callSettings.localVideoEnabled === 'undefined'
					? false
					: this.vm.callSettings.localVideoEnabled;
			});
	}

	stopShareScreen() {
		this.returnFromScreenShare();
	}

	shareScreen() {
		var videoSender: any = this.getVideoSender();
		if (!videoSender) return;

		navigator.mediaDevices.getDisplayMedia(/**{ cursor: true }*//** TODO ANGULAR_2:VALIDATE */)
			.then((screenStream) => {
				this.vm.screenStream = screenStream;
				this.vm.screenTrack = screenStream.getVideoTracks()[0];
				if (!this.vm.screenTrack) {
					this.stopScreenStream();
					return;
				}

				videoSender.replaceTrack(this.vm.screenTrack)
					.then(() => {
						this.vm.screenSharing = true;
					})
					.catch((error) => {
						this.stopScreenStream();
						console.error('Failed to start screen sharing.', error);
					});
				this.vm.screenTrack.onended = () => {
					this.returnFromScreenShare();
				}
			})
			.catch((error) => {
				console.error(error.message);
			});
	}

	returnFromScreenShare() {
		if (!this.vm.screenSharing && !this.vm.screenTrack && !this.vm.screenStream) return;

		var videoSender: any = this.getVideoSender();
		var localVideoTrack: any = this.getLocalVideoTrack();
		if (videoSender && localVideoTrack) {
			videoSender.replaceTrack(localVideoTrack)
				.catch((error) => {
					console.error('Failed to restore camera after screen sharing.', error);
				});
		}
		this.stopScreenStream();
	}

	getVideoSender() {
		if (!this.vm.peerConnectionSenders) return null;
		return this.vm.peerConnectionSenders.filter((sender) => {
			return sender && sender.track && sender.track.kind === 'video';
		})[0];
	}

	getLocalVideoTrack() {
		return this.vm.localStream && this.vm.localStream.getVideoTracks
			? this.vm.localStream.getVideoTracks()[0]
			: null;
	}

	stopScreenStream() {
		if (this.vm.screenTrack) {
			this.vm.screenTrack.onended = null;
			if (this.vm.screenTrack.readyState !== 'ended') {
				this.vm.screenTrack.stop();
			}
		}
		if (this.vm.screenStream) {
			this.vm.screenStream.getTracks().forEach((track) => {
				if (track.readyState !== 'ended') {
					track.stop();
				}
			});
		}
		this.vm.screenTrack = undefined;
		this.vm.screenStream = undefined;
		this.vm.screenSharing = false;
	}

	handleMediaInit() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		var mediaConstraints: any = this.vm.mediaConstraints;
		this.handleMediaDestroy(this.vm.localStream);
		this.updateSetupStatus('Starting camera and microphone', 'Requesting local media stream');
		this.logCallDebug('getUserMedia.request', mediaConstraints);
		console.log('Init media devices with constraints: ', mediaConstraints);

		navigator.mediaDevices.getUserMedia(mediaConstraints)
			.then((localStream) => {
				this.logCallDebug('getUserMedia.success', {
					audioTracks: localStream.getAudioTracks().length,
					videoTracks: localStream.getVideoTracks().length
				});
				console.info('Got local media');
				this.vm.localStream = localStream;

				this.vm.peerConnectionSenders = localStream.getTracks().map((track) => {
					console.log('Peer connection: track added', track);
					return this.vm.peerConnection.addTrack(track, localStream);
				});
				this.vm.callSettings.localAudioEnabled = typeof this.vm.callSettings.localAudioEnabled === 'undefined'
					? localStream.getAudioTracks().length > 0
					: this.vm.callSettings.localAudioEnabled;
				this.vm.callSettings.localVideoEnabled = typeof this.vm.callSettings.localVideoEnabled === 'undefined'
					? localStream.getVideoTracks().length > 0
					: this.vm.callSettings.localVideoEnabled;

				//var streamEl3: any = $('#localVideo'); // TODO ANGULAR_2:VALIDATE
				var streamEl3: HTMLVideoElement = document.getElementById('localVideo') as HTMLVideoElement;
				streamEl3.srcObject = localStream;
				console.log(streamEl3.srcObject);
				//var streamEl3: any = document.getElementById('localVideo');
				if (streamEl3) {
					streamEl3.muted = true;
				}

				deferred.resolve();
			})
			.catch((error) => {
				this.logCallDebug('getUserMedia.error', {
					name: error && error.name,
					message: error && error.message,
					constraints: mediaConstraints
				}, 'error');
				console.error(error.message);
				this.vm.callSettings.localAudioEnabled = typeof this.vm.callSettings.localAudioEnabled === 'undefined'
					? false
					: this.vm.callSettings.localAudioEnabled;
				this.vm.callSettings.localVideoEnabled = typeof this.vm.callSettings.localVideoEnabled === 'undefined'
					? false
					: this.vm.callSettings.localVideoEnabled;
				deferred.reject(error);
			});

		return deferred.promise;
	}

	handleMediaDestroy(stream) {
		if (!this.vm.peerConnectionSenders || !this.vm.peerConnection) return;
		this.vm.peerConnectionSenders.forEach((sender) => {
			console.log('Peer connection: track removed');
			this.vm.peerConnection.removeTrack(sender);
		});
		if (!stream) return;
		stream.getTracks().forEach((track) => { track.stop(); });
	}

	createAndSendOffer(peerConnection) {
		this.updateSetupStatus('Sending call offer', 'Creating local media setup');
		this.logCallDebug('createOffer.start');
		peerConnection.createOffer(this.config.getCallConfig().SDP_CONSTRAINTS)
			.then((offer) => {
				this.logCallDebug('createOffer.success', {
					type: offer && offer.type,
					sdpLength: offer && offer.sdp && offer.sdp.length
				});
				offer.sdp = offer.sdp.replace(/(m=video.*\r\n)/g, '$1b=AS:' + this.config.getCallConfig().BANDWIDTH + '\r\n');
				// if (webrtcAdapter.browserDetails.browser == 'safari') {
				// offer.sdp = this.removeCodec(offer.sdp, 'red');
				// offer.sdp = this.removeCodec(offer.sdp, 'ulpfec');
				// offer.sdp = this.removeCodec(offer.sdp, 'rtx');
				//}
				peerConnection.setLocalDescription(offer)
					.then(() => {
						this.updateSetupStatus('Sending call offer', 'Sending setup data to the other participant');
						this.logCallDebug('offer.setLocalDescription.success');
						this.callService.rtcOffer(offer,
							() => {
								this.updateSetupStatus('Finding network route', 'Exchanging network candidates');
								this.logCallDebug('rtcOffer.send.success');
								this.vm.handshakeComplete = true;
							},
							() => {
								this.updateSetupStatus('Could not send call setup data', 'Failed to send offer', true);
								this.recordFinalCallFailure('RTC_OFFER_SEND_FAILED', 'Could not send call setup data', 'Failed to send offer');
								this.logCallDebug('rtcOffer.send.error', null, 'error');
								this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
								console.error('SC failed to send offer.');
							}
						);
					})
					.catch((error) => {
						this.updateSetupStatus('Could not apply local call setup', this.getErrorDetail(error), true);
						this.recordFinalCallFailure('RTC_OFFER_LOCAL_DESCRIPTION_FAILED', 'Could not apply local call offer', this.getErrorDetail(error), error);
						this.logCallDebug('offer.setLocalDescription.error', error, 'error');
						this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
						console.error('Failed to set local description to offer.', error);
					});
			})
			.catch((error) => {
				this.updateSetupStatus('Could not create the call offer', this.getErrorDetail(error), true);
				this.recordFinalCallFailure('RTC_OFFER_CREATE_FAILED', 'Could not create the call offer', this.getErrorDetail(error), error);
				this.logCallDebug('createOffer.error', error, 'error');
				this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
				console.error('Failed to create offer', error);
			});
	}

	removeCodec(orgsdp, codec) {
		var internalFunc: any = (sdp) => {
			var codecre: any = new RegExp('(a=rtpmap:(\\d*) ' + codec + '\/90000\\r\\n)');
			var rtpmaps: any = sdp.match(codecre);
			if (rtpmaps == null || rtpmaps.length <= 2) {
				return sdp;
			}
			var rtpmap: any = rtpmaps[2];
			var modsdp: any = sdp.replace(codecre, '');

			var rtcpre: any = new RegExp('(a=rtcp-fb:' + rtpmap + '.*\r\n)', 'g');
			modsdp = modsdp.replace(rtcpre, '');

			var fmtpre: any = new RegExp('(a=fmtp:' + rtpmap + '.*\r\n)', 'g');
			modsdp = modsdp.replace(fmtpre, '');

			var aptpre: any = new RegExp('(a=fmtp:(\\d*) apt=' + rtpmap + '\\r\\n)');
			var aptmaps: any = modsdp.match(aptpre);
			var fmtpmap: any = '';
			if (aptmaps != null && aptmaps.length >= 3) {
				fmtpmap = aptmaps[2];
				modsdp = modsdp.replace(aptpre, '');

				var rtppre: any = new RegExp('(a=rtpmap:' + fmtpmap + '.*\r\n)', 'g');
				modsdp = modsdp.replace(rtppre, '');
			}

			var videore: any = /(m=video.*\r\n)/;
			var videolines: any = modsdp.match(videore);
			if (videolines != null) {
				//If many m=video are found in SDP, this program doesn't work.
				var videoline: any = videolines[0].substring(0, videolines[0].length - 2);
				var videoelem: any = videoline.split(' ');
				var modvideoline: any = videoelem[0];
				for (var i = 1; i < videoelem.length; i++) {
					if (videoelem[i] == rtpmap || videoelem[i] == fmtpmap) {
						continue;
					}
					modvideoline += ' ' + videoelem[i];
				}
				modvideoline += '\r\n';
				modsdp = modsdp.replace(videore, modvideoline);
			}
			return internalFunc(modsdp);
		};

		return internalFunc(orgsdp);
	}

	createAndSendAnswer(peerConnection, offer) {
		this.updateSetupStatus('Creating call answer', 'Applying remote offer');
		this.logCallDebug('answer.setRemoteDescription.start');
		peerConnection.setRemoteDescription(new RTCSessionDescription(offer))
			.then(() => {
				this.updateSetupStatus('Creating call answer', 'Creating local media setup');
				this.logCallDebug('answer.setRemoteDescription.success');
				this.logCallDebug('createAnswer.start');
				peerConnection.createAnswer(this.config.getCallConfig().SDP_CONSTRAINTS)
					.then((answer) => {
						this.logCallDebug('createAnswer.success', {
							type: answer && answer.type,
							sdpLength: answer && answer.sdp && answer.sdp.length
						});
						if (this.config.getCallConfig().BANDWIDTH) {
							answer.sdp = answer.sdp.replace(/(m=video.*\r\n)/g, '$1b=AS:' + this.config.getCallConfig().BANDWIDTH + '\r\n');
						}

						peerConnection.setLocalDescription(answer)
							.then(() => {
								this.updateSetupStatus('Sending call answer', 'Sending setup data to the other participant');
								this.logCallDebug('answer.setLocalDescription.success');
								this.callService.rtcAnswer(answer,
									() => {
										this.updateSetupStatus('Finding network route', 'Exchanging network candidates');
										this.logCallDebug('rtcAnswer.send.success');
										this.vm.handshakeComplete = true;
										this.drainOutboundIceCandidates();
										this.drainInboundIceCandidates();
									},
									() => {
										this.updateSetupStatus('Could not send call setup data', 'Failed to send answer', true);
										this.recordFinalCallFailure('RTC_ANSWER_SEND_FAILED', 'Could not send call setup data', 'Failed to send answer');
										this.logCallDebug('rtcAnswer.send.error', null, 'error');
										console.error('SC failed to send answer.');
										this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
									}
								);
							})
							.catch((error) => {
								this.updateSetupStatus('Could not apply local call setup', this.getErrorDetail(error), true);
								this.recordFinalCallFailure('RTC_ANSWER_LOCAL_DESCRIPTION_FAILED', 'Could not apply local call answer', this.getErrorDetail(error), error);
								this.logCallDebug('answer.setLocalDescription.error', error, 'error');
								console.error('setLocalDescriptionError : ' + error);
								this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
							});
					})
					.catch((error) => {
						this.updateSetupStatus('Could not create the call answer', this.getErrorDetail(error), true);
						this.recordFinalCallFailure('RTC_ANSWER_CREATE_FAILED', 'Could not create the call answer', this.getErrorDetail(error), error);
						this.logCallDebug('createAnswer.error', error, 'error');
						console.error('createAnswerError - ' + error);
						this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
					});
			})
			.catch((error) => {
				this.updateSetupStatus('Could not process the remote call setup', this.getErrorDetail(error), true);
				this.recordFinalCallFailure('RTC_OFFER_PROCESS_FAILED', 'Could not process the remote call offer', this.getErrorDetail(error), error);
				this.logCallDebug('answer.setRemoteDescription.error', error, 'error');
				console.error('setRemoteDescriptionError : ' + error);
				this.finishCall(this.vm.callEndedReasons.LOST_CONNECTION);
			});
	}

	drainInboundIceCandidates() {
		if (this.vm.handshakeComplete === true && this.vm.peerConnection) {
			while (this.vm.queuedInboundIceCandidates.length > 0) {
				var iceCandidate: any = this.vm.queuedInboundIceCandidates.shift();
				this.vm.peerConnection.addIceCandidate(new RTCIceCandidate(iceCandidate))
					.catch((error) => {
						console.error('Failed to add inbound ice candidate.', error);
					});
			}
		}
	}

	drainOutboundIceCandidates() {
		if (this.vm.handshakeComplete === true) {
			while (this.vm.queuedOutboundIceCandidates.length > 0) {
				var iceCandidate: any = this.vm.queuedOutboundIceCandidates.shift();
				this.logCallDebug('iceCandidate.send', {
					type: this.getIceCandidateType(iceCandidate && iceCandidate.candidate)
				});
				this.callService.rtcIceCandidate(iceCandidate,
					() => {
						// Do nothing
					},
					(error) => {
						console.error('SC failed to drain outbound ice candidate.', error);
					}
				);
			}
		}
	}

	getIceCandidateType(candidate) {
		if (!candidate) return null;
		var match: any = candidate.match(/ typ ([a-zA-Z0-9]+)/);
		return match && match[1] || null;
	}

	updateSetupStatus(message, detail?, isError?) {
		if (!this.vm || !this.vm.setupStatus) return;
		if (this.vm.setupStatus.isError && !isError) return;
		this.vm.setupStatus.visible = true;
		this.vm.setupStatus.message = message;
		this.vm.setupStatus.detail = detail;
		this.vm.setupStatus.isError = !!isError;
	}

	clearSetupStatus() {
		if (!this.vm || !this.vm.setupStatus) return;
		if (this.vm.setupStatus.isError) return;
		this.vm.setupStatus.visible = false;
	}

	getErrorDetail(error) {
		if (!error) return undefined;
		if (typeof error === 'string') return error;
		var parts: any = [];
		if (error.code) parts.push(error.code);
		if (error.name) parts.push(error.name);
		if (error.message) parts.push(error.message);
		return parts.length ? parts.join(': ') : JSON.stringify(error);
	}

	getMediaErrorMessage(error) {
		if (!error) return 'Could not start camera or microphone';
		switch (error.name) {
			case 'NotAllowedError':
				return 'Camera or microphone permission was blocked';
			case 'NotReadableError':
				return 'Camera or microphone is already in use';
			case 'OverconstrainedError':
				return 'Selected camera or microphone is no longer available';
			case 'NotFoundError':
				return 'No microphone or camera was found';
			default:
				return 'Could not start camera or microphone';
		}
	}

	recordFinalCallFailure(alertCode, message, detail?, context?) {
		if (this.vm.finalCallFailure) return;
		this.vm.finalCallFailure = {
			alertCode: alertCode || 'CALL_FAILURE',
			message: message || 'Call failed',
			detail: detail,
			context: context,
			timestamp: new Date().toISOString()
		};
	}

	reportFinalCallFailure(reason) {
		if (!this.vm.finalCallFailure || this.vm.finalCallFailureAlertSent) return;
		this.vm.finalCallFailureAlertSent = true;

		var sessionData: any = this.session.getSession && this.session.getSession();
		var sessionUser: any = sessionData && sessionData.user || {};
		var peerConnection: any = this.vm.peerConnection;
		var payload: any = {
			alertCode: this.vm.finalCallFailure.alertCode,
			message: this.vm.finalCallFailure.message,
			detail: this.vm.finalCallFailure.detail,
			reason: reason,
			source: 'CallView',
			context: this.safeCopyCallFailureContext(this.vm.finalCallFailure.context),
			sessionUser: {
				id: sessionUser.id,
				userId: sessionUser.userId,
				name: sessionUser.firstname || sessionUser.lastname ? ((sessionUser.firstname || '') + ' ' + (sessionUser.lastname || '')).trim() : sessionUser.name,
				username: sessionUser.username,
				origin: sessionUser.origin
			},
			call: {
				callType: this.vm.callType,
				callMediumType: this.vm.callMediumType,
				activeCallState: this.vm.activeCallState,
				uid: this.vm.uid,
				bookingId: this.vm.bookingId,
				consultant: this.vm.consultant,
				testCall: this.vm.testCall,
				endpointUser: this.getCallFailureEndpointUser(),
				setupStatus: this.vm.setupStatus,
				handshakeComplete: this.vm.handshakeComplete,
				iceConnection: this.vm.iceConnection,
				connectionEstablished: this.vm.connectionEstablished,
				peerConnectionState: peerConnection && peerConnection.connectionState,
				iceConnectionState: peerConnection && peerConnection.iceConnectionState,
				iceGatheringState: peerConnection && peerConnection.iceGatheringState,
				signalingState: peerConnection && peerConnection.signalingState,
				lastIceCandidateError: this.vm.lastIceCandidateError
			},
			browser: {
				userAgent: navigator.userAgent,
				platform: navigator.platform
			},
			page: {
				pathname: window.location.pathname,
				search: window.location.search
			},
			timestamp: this.vm.finalCallFailure.timestamp
		};

		this.serviceRestServices.reportCallFailure(payload,
			() => {
				this.logCallDebug('callFailureAlert.sent', { alertCode: payload.alertCode });
			},
			(error) => {
				this.logCallDebug('callFailureAlert.failed', {
					alertCode: payload.alertCode,
					status: error && error.status
				}, 'error');
			}
		);
	}

	getCallFailureEndpointUser() {
		if (!this.vm.endpointUser) return null;
		return {
			id: this.vm.endpointUser.id,
			userId: this.vm.endpointUser.userId,
			localUserId: this.vm.endpointUser.localUserId,
			endpoint: this.vm.endpointUser.endpoint,
			firstName: this.vm.endpointUser.firstName,
			lastName: this.vm.endpointUser.lastName,
			customerId: this.vm.endpointUser.customerId
		};
	}

	safeCopyCallFailureContext(context) {
		if (!context) return context;
		try {
			return JSON.parse(JSON.stringify(context));
		} catch (error) {
			return this.getErrorDetail(context);
		}
	}

	logCallDebug(event, data?, level = 'info') {
		var payload: any = {
			event: event,
			data: data,
			activeCallState: this.vm && this.vm.activeCallState,
			callType: this.vm && this.vm.callType,
			timestamp: new Date().toISOString()
		};
		if (level === 'error') {
			console.error('CALL.DEBUG', payload);
		} else {
			console.info('CALL.DEBUG', payload);
		}
	}

	finishCall(reason) {
		this.logCallDebug('finishCall', { reason: reason });
		console.info('CallModule.FinishCall');
		if (this.vm.activeCallState === this.vm.callState.ENDED) return;
		this.reportFinalCallFailure(reason);

		if (this.vm.audioRecordingAllowed
			&& typeof (this.vm.mediaRecorder) !== 'undefined'
			&& this.vm.mediaRecorder !== null
			&& this.vm.callType === this.config.getCallConfig().CALL_TYPE.OUTGOING
			&& (this.vm.callSettings.localAudioEnabled || this.vm.callSettings.remoteAudioEnabled)) {
			this.stopRecording();
			this.download();
		}

		this.vm.callSettings.localAudioEnabled = false;
		this.vm.callSettings.localVideoEnabled = false;
		this.vm.callSettings.remoteAudioEnabled = false;
		this.vm.callSettings.remoteVideoEnabled = false;
		this.vm.callEndedReason = reason;
		this.clearTimeoutTimers();

		this.ngZone.run(() => {
			this.vm.activeCallState = this.vm.callState.ENDED;
		});
		
		if (this.vm.peerConnection) {
			try {
				this.vm.peerConnection.ontrack = null;
				this.vm.peerConnection.onicecandidate = null;
				this.vm.peerConnection.onicecandidateerror = null;
				this.vm.peerConnection.oniceconnectionstatechange = null;
				if (this.vm.peerConnection.signalingState !== 'closed') {
					this.vm.peerConnection.close();
				}
			} catch (error) {
				console.warn('Failed to close peer connection cleanly.', error);
			}
			this.vm.peerConnection = null;
		}

		this.stopMediaStreams();
		this.vm.remoteStream = null;

		this.callService.stopWaitingSound();
		this.callService.stopRinging();

		var localVideo: HTMLVideoElement = document.getElementById('localVideo') as HTMLVideoElement;
		var remoteVideo: HTMLVideoElement = document.getElementById('remoteVideo') as HTMLVideoElement;
		if (localVideo) localVideo.srcObject = null;
		if (remoteVideo) remoteVideo.srcObject = null;
		$('#localVideo').removeAttr('src');
		$('#remoteVideo').removeAttr('src');
		this.vm.handshakeComplete = false;

		var callMinutes: any = this.vm.timer && this.vm.timer.getMinutes() || 0;
		var callHours: any = this.vm.timer && this.vm.timer.getHours() || 0;
		this.vm.timer = new Date(0, 0);
		this.vm.formattedTimer = '0:00';

		this.vm.connectionEstablished = false;

		// Open feedback modal
		if ((callMinutes > 4 || callHours > 0)
			&& (this.vm.callEndedReason === this.vm.callEndedReasons.ENDED
				|| this.vm.callEndedReason === this.vm.callEndedReasons.HUNG_UP)) {
			var dialog = this.dialogServices.show({
				controller: ModalUserFeedbackComponent,
				subject: this.vm.endpointUser,
				clickOutsideToClose: false,
				escapeToClose: false,
				multiple: false,
			});
			dialog.afterClosed().subscribe((response) => {
				if (!!response && response.isPatientEvaluatesSession) {
					this.dialogServices.show({
						controller: ModalUserSessionFeedbackComponent,
						userId: response.userId,
						subject: response.subject,
						isPatientEvaluatesSession: response.isPatientEvaluatesSession,
						clickOutsideToClose: false,
						escapeToClose: false,
						multiple: false,
					});
				}
			});
		}
	}

	clearTimeoutTimers() {
		this.time.deleteTimer(this.config.getTimerConfig().Call.CALLING_TIMER);
		this.time.deleteTimer(this.config.getTimerConfig().Call.REQUEST_DISCONNECTED);
		this.time.deleteTimer(this.config.getTimerConfig().Call.CALL_DISCONNECTED);
	}

	stopMediaStreams() {
		if (this.vm.localStream) {
			for (var mediaStreamId in this.vm.localStream.getTracks()) {
				this.vm.localStream.getTracks()[mediaStreamId].stop();
			}
		}
		if (this.vm.screenStream && this.vm.screenTrack) {
			this.vm.screenTrack.stop();
		}
	}

	initChat() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		this.vm.chat = this.vm.chat || {};
		if (this.vm.chat.id) {
			deferred.resolve();
			return deferred.promise;
		}
		this.chatRestServices.getChatByFriendId({ friendUserId: this.vm.endpointUser.userId }, (chat) => {
			this.vm.chat.id = chat.id;
			deferred.resolve();
		});
		return deferred.promise;
	}

	toggleChat() {
		if (this.vm.chat && this.vm.chat.open) {
			this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Chat.CLOSE, this.vm.chat);
			this.vm.chat.open = false;
		} else {
			if (this.vm.endpointUser) {
				var user: any = {
					id: this.vm.endpointUser.userId,
					firstname: this.vm.endpointUser.firstName,
					lastname: this.vm.endpointUser.lastName,
					profilePicture: {
						thumbnailUrl: this.vm.endpointUser.photoUrl
					}
				};

				this.initChat().then(() => {
					this.chatService.openChatById(user, this.vm.chat.id);
					this.vm.chat.open = true;
					this.vm.chat.unread = false;
				});
			}
		}
	}

	toggleNotes() {
		if (!this.vm.isDoctor) return;
		if (!this.vm.notesAllowed) {
			this.toast.showAsync(
				this.angularFilterHelperService.translate('Services.Other.Notes_Disabled'),
				this.angularFilterHelperService.translate('Common.Got_It')
			);
			return;
		}
		this.vm.notes.open = !this.vm.notes.open;
		this.angularBroadcastHelperService.rootBroadcast("toggleNotesDrawer", this.vm.notes);
	}

	initAudioRecording() {
		if (this.vm.audioContext) return false;
		console.info('Initializing audio recording ...');
		var _window: any = window;// TODO ANGULAR_2:VALIDATE
		var AudioContext: any = _window.AudioContext || _window.webkitAudioContext || false;
		if (!AudioContext) {
			console.warn('Web Audio API not supported');
			return false;
		}

		this.vm.audioContext = new AudioContext();
		this.vm.mixedStream = this.vm.audioContext.createMediaStreamDestination();
		this.vm.mixedStream.channelCount = 1;
		this.vm.mixedStream.channelCountMode = 'explicit';
		this.vm.mixedStream.channelInterpretation = 'speakers';
		if (this.vm.callSettings.localAudioEnabled) {
			console.info('Creating local audio source ...');
			this.vm.localAudioSource = this.vm.audioContext.createMediaStreamSource(new MediaStream(this.vm.localStream.getAudioTracks()));
			this.vm.localAudioSource.connect(this.vm.mixedStream);
		}
		if (this.vm.callSettings.remoteAudioEnabled) {
			console.info('Creating remote audio source ...');
			this.vm.remoteAudioSource = this.vm.audioContext.createMediaStreamSource(new MediaStream(this.vm.remoteStream.getAudioTracks()));
			this.vm.remoteAudioSource.connect(this.vm.mixedStream);
		}

		return true;
	}

	startRecording() {
		console.info('Starting audio recording ...');
		var _window: any = window; // TODO ANGULAR_2:VALIDATE
		var MediaRecorder: any = _window.MediaRecorder || _window.webkitMediaRecorder || false;
		if (!MediaRecorder) {
			console.warn('MediaRecorder API not supported');
			return;
		}
		this.vm.audioRecording = true;
		this.vm.mediaBlobs = [];
		try {
			this.vm.mediaRecorder = new MediaRecorder(this.vm.mixedStream.stream, {
				mimeType: 'audio/webm;codecs=opus',
				audioBitsPerSecond: 16000
			});
		} catch (e) {
			console.error('Exception while creating MediaRecorder: ' + e);
			return;
		}
		this.vm.mediaRecorder.onstart = (event) => {
			console.info('Media recorder started');
		};
		this.vm.mediaRecorder.onstop = (event) => {
			console.info('Media recorder stopped');
		};
		this.vm.mediaRecorder.ondataavailable = (event) => {
			this.vm.mediaBlobs.push(event.data);
		};
		this.vm.mediaRecorder.start(100);
	}

	// toggleRecording() {
	// 	if (this.vm.audioRecordingAllowed) {
	// 		if (this.vm.audioRecording) {
	// 			this.stopRecording();
	// 			this.download();
	// 		} else if (this.vm.audioRecordingEnabled) {
	// 			this.startRecording();
	// 		}
	// 	}
	// }

	stopRecording() {
		this.vm.mediaRecorder.stop();
		this.vm.mediaRecorder = null;
		this.vm.audioRecording = false;
	}

	download() {
		var blob: any = new Blob(this.vm.mediaBlobs, { type: 'audio/webm' });
		var url: any = URL.createObjectURL(blob);
		var a: any = document.createElement('a');
		document.body.appendChild(a);
		a.style = 'display: none';
		a.href = url;
		var d: any = this.vm.callStartTime;
		var callStartTime: any = d.getFullYear() + this.pad(d.getMonth() + 1) + this.pad(d.getDate()) + '_' +
			this.pad(d.getHours()) + this.pad(d.getMinutes()) + this.pad(d.getSeconds());
		a.download = callStartTime + '_' + this.vm.endpointUser.userCode + '.webm';
		a.click();
		setTimeout(() => {
			document.body.removeChild(a);
			URL.revokeObjectURL(url);
		}, 100);

	}

	pad(n) {
		return ('0' + n).slice(-2);
	}

	handleChatClose(event, chat) {
		if (chat.id == this.vm.chat.id) this.vm.chat.open = false;
	}

	handleNewMessage(event, message, chatId) {
		this.initChat().then(() => {
			this.vm.chat.unread = !this.vm.chat.open && this.vm.chat.id == chatId;
		});
	}

	createDownloadNotification() {
		var downloadOnFinish: any = this.vm.audioRecordingAllowed
			&& typeof (this.vm.mediaRecorder) !== 'undefined'
			&& this.vm.mediaRecorder !== null
			&& this.vm.callType === this.config.getCallConfig().CALL_TYPE.OUTGOING
			&& (this.vm.callSettings.localAudioEnabled || this.vm.callSettings.remoteAudioEnabled);
		if (!downloadOnFinish) return;

		var notification: any = {
			isVisible: true,
			icon: 'download',
			text: this.angularFilterHelperService.translate('Call.Content.Call_Stored'),
			btnText: this.angularFilterHelperService.translate('Common.Got_It'),
			action: () => {
				this.vm.notification.isVisible = false;
			}
		};
		this.vm.notification = notification;
	}

}
